import { render, staticRenderFns } from "./caption.vue?vue&type=template&id=d671f994&scoped=true"
import script from "./caption.vue?vue&type=script&lang=js"
export * from "./caption.vue?vue&type=script&lang=js"
import style0 from "./caption.vue?vue&type=style&index=0&id=d671f994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d671f994",
  null
  
)

export default component.exports